import React from "react"
import { UserCircleIcon } from "@heroicons/react/solid"
import type { DesignerUser } from "models/DesignerUser"

interface IDesignerNameSquare {
  user?: DesignerUser
}

const DesignerNameSquare = ({ user }: IDesignerNameSquare) => (
  <div
    className="flex md:w-auto h-10 items-center justify-center px-2 bg-white border-gray-300 border"
    data-testid="ba-designer-name"
  >
    <UserCircleIcon className="object-cover p-1 md:mr-2 h-9 w-9 text-gray-300" />
    <div className="font-sans p-1 text-gray-900 text-sm md:mx-0 mx-2">
      <div className="cursor-pointer justify-center">
        {user?.designer?.name}
      </div>
    </div>
  </div>
)

export default DesignerNameSquare
